import {Component} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-feature-unavailable',
  templateUrl: './dialog-feature-unavailable.component.html'
})
export class DialogFeatureUnavailableComponent {
  constructor(private dialogRef: MatDialogRef<DialogFeatureUnavailableComponent>) {
  }

  onClose() {
    this.dialogRef.close();
  }

  onOpenNewVersion() {
    // Substitua pela URL da nova versão
    window.open('https://app.apureh.com', '_self');
    this.dialogRef.close();
  }
}